import { Microapp } from 'signup-constants/Microapp';
export const getInvoiceGeneratorState = state => {
  return state.microapp && state.microapp[Microapp.InvoiceGenerator];
};